import React, {Component} from 'react';
import '../App.css';
import '../css/all.css';



import UpperMenu from '../components/upper_menu/upper_menu.component'
import compose from '../utils/compose'
import withNofeshService  from '../hoc/withNofeshService.hoc';
import ModalHotelDetails from '../components/hotels_list/modal_hotel_details.component'




class HotelDetailsPage extends Component {

  state = {
    loading:true,
    currentHotel :{},
    modalHotelDisplay:false,
    loadingCurrentHotel:true
  }




  setModalHotelDisplayOpened = () => {
    this.setState({ modalHotelDisplay: true});
  }

  
  setModalHotelDisplayClosed = () => {
    this.setState({ modalHotelDisplay: false});
  }




    componentDidMount = () => {
        console.log('HotelDetailsPage componentDidMount ');


        let hotelId = "1";
        const { nofeshService } = this.props;
        nofeshService.getHotelDetails(hotelId).then( res  => {
          console.log('HotelDetailsPage componentDidMount getHotelDetails res', res);
          this.setState({currentHotel: res.data, loading:false }); ;            
        }); 
   }




    render() {         


      return (      
          <React.Fragment>                          
              <div className="hp_banner">
                  <UpperMenu  
                    personData={this.props.personData}
                    onLoggedOutRefresh={this.props.onLoggedOutRefresh}/>
  
                  {(this.state.currentHotel) ?     
              
                    <ModalHotelDetails 
                        hotel={this.state.currentHotel}
                        setModalHotelDisplayClosed={this.setModalHotelDisplayClosed} >
                    </ModalHotelDetails>
                  :null}
              </div>
  
              <div className="hp_container">                                          
            </div>
              <div className="hp_footer">
              </div>
        </React.Fragment>
      )
    }
}



export default compose(
    withNofeshService(),    
  )(HotelDetailsPage);



